import {
    CaretRightOutlined,
    RightOutlined,
    PrinterOutlined,
    EyeOutlined,
    CheckCircleTwoTone,
} from "@ant-design/icons";
import {
    Collapse,
    Row,
    Col,
    Button,
    Form,
    Input,
    Select,
    DatePicker,
    Alert,
    notification,
    Typography,
    Space,
    Spin,
    Card,
    Avatar,
    Descriptions,
    Modal,
    Radio
} from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useParams, useHref, useLocation } from "react-router-dom";

import memberService from "../../api/member.service";
import ProgrammeCommercialService from "../../api/programme.commercial.service";
import ProgrammeService from "../../api/programme.service";

import timeSlotService from "../../api/time.slot.service";

import {
    DATE_FORMAT_DMY_SLASH,
    MEMBER_ACCOUNT_ID,
    ROUND_OFF_ACCOUNT_ID,
    SAVE_SUCCESS_MSG,
    SUCCESS_STATUS,
    UPDATE_SUCCESS_MSG,
    BANK_CHARGES_ACCOUNT_ID,
    ADD_ONE_PAYMENT_MODE,
    EDIT_MODE,
    ADD_MODE,
    PAYMENT_SECTION_REQUIRED_MESSAGE,
    TAP_MEMBERSHIP_ADMISSION_CREDIT_ACCOUNT_ID,
    CGST_ID_9_PERCENT,
    SGST_ID_9_PERCENT,
    TAP_TAG
} from "../../utility/Constants";

import TimeSlotEnrollment from "../enrollment/TimeSlotEnrollment";
import moment from "moment";
import enrollmentService from "../../api/enrollment.service";
import commonUtility from "../../utility/Utils";
import EnrollmentComponent from "../enrollment/commercial-components/EnrollmentComponent";
import accountService from "../../api/account.service";
import OtherItems from "../enrollment/commercial-components/OtherItems";
import TestFormItem from "../enrollment/commercial-components/TestFormItem";
import PaymentComponent from "../enrollment/commercial-components/PaymentComponent";
import paymentService from "../../api/payment.service";
import StudentCardInfo from "../common/StudentCardInfo";
import { useSelector } from "react-redux";
import ModalWithMessageAndAction from "../common/ModalWithMessageAndAction";
import Paragraph from "antd/lib/skeleton/Paragraph";
import { PRINT_BASE_URL } from "../../utility/URL";
import clubService from "../../api/clubaffiliation.service";
import BTATournamentDetailView from "../btatournamentcomponent/BTATournamentDetailView";
import generalCustomerService from "../../api/general.customer.service";


const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;
const { Title } = Typography;

const defaultFormValues = {
    mode: "ADD",  
    voucher_id: 0,
    cr_ac_id: 0,
    member_opening_balance: 0,
    receipt_id: 0,
    receipt_no: "",
    receipt_date: null,
    invoice_date: null,
    invoice_number: "",
    is_payment_done: "N",
    no_of_months: 0,
    entry_from: "G",
    is_general_receipt: "Y",
    round_off_amount: 0,
    round_off_account_id: ROUND_OFF_ACCOUNT_ID,
    total_bank_charges: 0,
    bank_charges_account_id: BANK_CHARGES_ACCOUNT_ID,
    is_gst_bill: 'Y',
    net_amount: 0,
    receipt_desc: "",   
    taxable_amount: 0,
    cgst_id: CGST_ID_9_PERCENT,
    cgst_rate: 9,
    cgst_amount: 0,
    sgst_id: SGST_ID_9_PERCENT,
    sgst_rate: 9,
    sgst_amount: 0,   
    general_receipt_detail:[]
};

const TournamentEntry = () => {
    const [form] = Form.useForm();

    const params = useParams();

    let navigate = useNavigate();
    const location = useLocation();
    // const { pathname, search, hash } = location;
    //const href  = useHref();


    const state = useSelector((state) => state.otheritem);


    const [printURL, setPrintURL] = useState("");
    const [enrollmentID, setEnrollmentID] = useState(0);
    const [receiptID, setReceiptID] = useState(0);
    const [paymentID, setPaymentID] = useState(0);





    const [accountList, setAccountList] = useState([]);

    const [isFormChanged, setIsFormChanged] = useState(false);

    const [totalAmount, setTotalAmount] = useState(0);
    const [totalDiscountAmount, setTotalDiscountAmount] = useState(0);
    const [totalTaxableAmount, setTotalTaxableAmount] = useState(0);
    const [totalCGSTAmount, setTotalCGSTAmount] = useState(0);
    const [totalSGSTAmount, setTotalSGSTAmount] = useState(0);
    const [totalPayableAmount, setTotalPayableAmount] = useState(0);
    const [totalNetAmount, setTotalNetAmount] = useState(0);
    const [totalRoundOff, setTotalRoundOff] = useState(0);
    const [totalBankCharges, setTotalBankCharges] = useState(0);


    // Payment useState
    const [paymentPaidList, setPaymentPaidList] = useState([]);
    const [totalPaidAmount, setTotalPaidAmount] = useState(0);
    const [remainingAmount, setRemainingAmount] = useState(0);

    const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);

    const [openModal, setOpenModal] = useState(false);
    const [responseModalTitle, setResponseModalTitle] = useState("");
    const [responseModalMessage, setResponseModalMessage] = useState("");


    const [tournamentList, setTournamentList] = useState([]);
    const [tournamentDetailList, setTournamentDetailList] = useState([]);
    const [customerList, setCustomerList] = useState([]);

    useEffect(() => {
        generalCustomerService.list().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                //setAccountList(res.data.response_data);
                setCustomerList(res.data.response_data);
            }

        });
    }, []);



    const onTournamentSave = async (values) => {


        // console.log("values", values);
        //return false;

        if (values.payment_data.length > 0) {
            //debugger;
            setPrintURL("");
            setSaveLoaderEnable(true)
            const data = { formdata: values };
            setOpenModal(false);
            setResponseModalTitle("")
            setResponseModalMessage("")

            ProgrammeService.tournamentAction(data).then((res) => {
                if (res.data.response_status == SUCCESS_STATUS && res.data.response_data.affectedRows == undefined) {
                    const resp_data = res.data.response_data;

                    setOpenModal(true)
                    setResponseModalTitle("Success")
                    setResponseModalMessage(`${SAVE_SUCCESS_MSG}`)

                    const print_url = `${PRINT_BASE_URL}taxinvoice/generalreceiptprint/${resp_data.receipt_master_id}/${resp_data.payment_master_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`
                    setPrintURL(print_url);


                } else if (res.data.response_data.affectedRows > 0) {
                    const resp_data = res.data.response_data;

                    setOpenModal(true)
                    setResponseModalTitle("Success")
                    setResponseModalMessage(`${UPDATE_SUCCESS_MSG}`)

                    const print_url = `${PRINT_BASE_URL}taxinvoice/generalreceiptprint/${resp_data.receipt_master_id}/${resp_data.payment_master_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`
                    setPrintURL(print_url);

                }
                setSaveLoaderEnable(false)

            }).then(() => {
                setSaveLoaderEnable(false)
            });
        } else {
            commonUtility.openNotificationWithType("error", "bottomRight", "Error", ADD_ONE_PAYMENT_MODE);
        }



    };

    const onChangeCollapse = (key) => {
        console.log(key);
    };

    /*
        const onSelectProgrammeGroup = (value, event) => {
          setProgrammeGroupID(value);
          form.setFieldsValue({ day_slot: [] });
      
        };
        */


    useEffect(() => {
        const rcpt_dt = commonUtility.dateFormatDDMMYYYY(new Date(), "/");
        form.setFieldsValue({
            receipt_date: rcpt_dt,
        });
    }, []);


    useEffect(() => {
        setTournamentList([]);

    }, []);

    useEffect(() => {
        setTournamentList([]);
        ProgrammeService.tournamentList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setTournamentList(res.data.response_data);
            }
        });
    }, []);



    const onDateChange = (date, dateString) => {
        form.setFieldsValue({
            invoice_date: dateString,
        });
    };


    const onFormCalculation = () => {
        // console.log('tests');
        setIsFormChanged(false);
        //debugger;
        let total_amount = form.getFieldValue("general_receipt_detail").reduce((total, obj) => {
            const amount = parseFloat(obj?.amount) || 0; 
            return amount + parseFloat(total);
        }, 0);

        let total_cgst_amount = form.getFieldValue("general_receipt_detail").reduce((total, obj) => {
            const cgst = parseFloat(obj?.cgst_amount) || 0; 
            return cgst + parseFloat(total);
        }, 0);

        let total_sgst_amount = form.getFieldValue("general_receipt_detail").reduce((total, obj) => {
            const sgst = parseFloat(obj?.sgst_amount) || 0; 
            return sgst + parseFloat(total);
        }, 0);
       
        
        let total_taxable = total_amount;
        let net_amt = total_amount+total_cgst_amount+total_sgst_amount;
        form.setFieldsValue({
            total_taxable: total_taxable.toFixed(2),
            total_cgst_amount: total_cgst_amount.toFixed(2),
            total_sgst_amount: total_sgst_amount.toFixed(2),
            net_amount: net_amt.toFixed(2)  
        });

        let total_discount = 0;
        let total_gst_amt = parseFloat(commonUtility.sanitizeValue(total_cgst_amount)) + parseFloat(commonUtility.sanitizeValue(total_sgst_amount));
        let total_payable_amount = parseFloat(commonUtility.sanitizeValue(total_taxable)) + total_gst_amt;

        const payableAmountDetail = commonUtility.getRoundOfAmount(total_payable_amount);
        const new_payable_amount = payableAmountDetail.newPayableAmount;
        const roundoff_amount = payableAmountDetail.roundoffAmount;

        form.setFieldsValue({
            payable_amount: new_payable_amount,
            round_off_amount: roundoff_amount,
        });

        setTotalAmount(total_taxable.toFixed(2));
        setTotalDiscountAmount(total_discount.toFixed(2));
        setTotalTaxableAmount(total_taxable.toFixed(2));
        setTotalCGSTAmount(total_cgst_amount.toFixed(2));
        setTotalSGSTAmount(total_sgst_amount.toFixed(2));
        setTotalNetAmount(total_payable_amount.toFixed(2));
        setTotalPayableAmount(new_payable_amount.toFixed(2));

        setTotalRoundOff(0);
        if (roundoff_amount) {
            setTotalRoundOff(`${roundoff_amount}`);
        }

        setIsFormChanged(true);

    };


    useEffect(() => {
        onFormCalculation();
    }, [form]);



    // Payment mode Data
    const [isPaymentModeDisabled, setIsPaymentModeDisabled] = useState(false);
    const addPaymentMode = () => {
        const selected_payment_mode_text = form.getFieldValue("selected_payment_mode_text");
        const mode = form.getFieldValue("selected_payments_mode");
        const paid_amount = form.getFieldValue("paid_amount");
        const dr_account_id = form.getFieldValue("dr_account_id");
        const cheque_no = form.getFieldValue("cheque_no");
        const cheque_date = form.getFieldValue("cheque_date");
        const bank = form.getFieldValue("bank");
        const branch = form.getFieldValue("branch");
        const bank_charges = commonUtility.sanitizeValue(form.getFieldValue('bank_charges'));
        const payment_ref = form.getFieldValue('payment_ref');

        let bank_charges_amount = 0;
        if (commonUtility.sanitizeValue(bank_charges) > 0) {
            bank_charges_amount = (parseFloat(paid_amount) * parseFloat(bank_charges)) / 100;
            bank_charges_amount = Math.round(bank_charges_amount);
        }

        //setIsOtherComponentRender(false)

        if (
            commonUtility.sanitizeObject(selected_payment_mode_text) &&
            commonUtility.sanitizeObject(mode) && commonUtility.sanitizeValue(paid_amount) >= 0
        ) {
            let amount = parseFloat(paid_amount) + parseFloat(bank_charges_amount);
            setPaymentPaidList([
                ...paymentPaidList,
                {
                    rowKey: commonUtility.randomID(),
                    mode_description: selected_payment_mode_text,
                    payment_mode_text: selected_payment_mode_text,
                    payment_mode_id: mode,
                    payment_mode: mode,
                    dr_account_id: dr_account_id,
                    amount: amount,
                    paid_amount: paid_amount,
                    cheque_no: cheque_no,
                    cheque_date: cheque_date,
                    bank_name: bank,
                    bank_branch: branch,
                    bank_charges: bank_charges_amount,
                    payment_ref: payment_ref,
                },
            ]);

            setIsPaymentModeDisabled(true);

            form.setFieldsValue({
                selected_payment_mode_text: "",
                selected_payments_mode: "",
                cheque_no: "",
                cheque_date: "",
                bank: "",
                payment_ref: "",
            });
        }
        else {
            commonUtility.openNotificationWithType("error", "bottomRight", "Error", PAYMENT_SECTION_REQUIRED_MESSAGE);
        }
    };

    // Remove payment Mode
    const removePayment = (index) => {
        const list = [...paymentPaidList];
        list.splice(index, 1);
        setPaymentPaidList(list);

        if (list.length === 0) {
            setIsPaymentModeDisabled(false);
          }
    };



  


    /***************************************ADD MODE***************************/
    /***************************************ADD MODE***************************/
    /***************************************ADD MODE***************************/
    useEffect(() => {
        //setEnrollmentID(params.enrollmentid);
        setReceiptID(params.receiptid);
        setPaymentID(params.paymentid);
    }, []);




    /** ****************************************************************************
     * ******************************* Edit Mode ***********************************
     * *****************************************************************************
     */


    /**
     * Set Total Payment Amount Data
     */


    useEffect(() => {
        if (receiptID > 0) {
            const data = {
                formdata: {
                    receipt_id: receiptID,
                },
            };


            enrollmentService.JCPReceiptDatabyID(data).then((res4) => {
                if (res4.data.response_status === SUCCESS_STATUS) {

                    setTotalAmount(0);
                    setTotalDiscountAmount(0);
                    setTotalTaxableAmount(0);
                    setTotalCGSTAmount(0);
                    setTotalSGSTAmount(0);
                    setTotalNetAmount(0);
                    setTotalPayableAmount(0);

                    const receipt_datam = res4.data.response_data[0];

                   
                    // console.log(receipt_datam.bill_type);

                    form.setFieldsValue({
                        receipt_id: receipt_datam.receipt_id,
                        invoice_number: receipt_datam.receipt_no,
                        receipt_desc: receipt_datam.customer_id,
                        total_gst_amount: 0,
                        total_taxable: receipt_datam.total_amount,
                        total_cgst_amount:receipt_datam.total_cgst_amount,
                        total_sgst_amount:receipt_datam.total_sgst_amount,
                        net_amount:receipt_datam.net_payble_amount,
                        // taxable_amount:receipt_datam.net_payble_amount,
                        payable_amount:receipt_datam.net_payble_amount,
                        is_gst_bill: receipt_datam.bill_type === "NONGST" ? "N" : "Y",
                    });

                    setTotalAmount(receipt_datam.total_amount.toFixed(2));
                    setTotalTaxableAmount(receipt_datam.total_amount.toFixed(2));
                    setTotalCGSTAmount(receipt_datam.total_cgst_amount.toFixed(2));
                    setTotalSGSTAmount(receipt_datam.total_sgst_amount.toFixed(2));

                    const total_net_amount = receipt_datam.net_payble_amount;
                    setTotalNetAmount(total_net_amount.toFixed(2));
                    setTotalPayableAmount(receipt_datam.net_payble_amount.toFixed(2));

                }
            });

            enrollmentService.TournamentReceiptData(data).then((res4) => {
                if (res4.data.response_status === SUCCESS_STATUS) {
                    const receipt_datam = res4.data.response_data;
                    setTournamentDetailList(receipt_datam);
                    // form.setFieldsValue({
                    //     general_receipt_detail: receipt_datam,
                    // });

                }
            });


          



        }
    }, [receiptID]);





    /**
     * payment Info && Payment List Detail
     */

    useEffect(() => {
        if (receiptID > 0 && paymentID > 0) {
            const data = {
                formdata: {
                    payment_id: paymentID,
                },
            };
            paymentService.clubPaymentmasterDataByID(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    setTotalPaidAmount(0);
                    setTotalRoundOff(0);

                    const payment_data = res.data.response_data[0];
                    form.setFieldsValue({
                        mode: "EDIT",
                        payment_id: payment_data.payment_id,
                        payment_date: payment_data.payment_date,
                        date_of_payment: payment_data.payment_date
                            ? moment(payment_data.payment_date, DATE_FORMAT_DMY_SLASH)
                            : "",

                        //member_opening_balance: payment_data.short_excess_amount,
                        payment_amount: payment_data.payment_amount,
                        voucher_id: payment_data.voucher_id,
                        // receipt_no: payment_data.payment_no,
                        payable_amount: payment_data.total_payble_amount,
                        //no_of_years: payment_data.no_of_years,
                        //rate_per_year: payment_data.rate_per_year,
                        narration: payment_data.narration,
                        round_off_amount: payment_data.round_off_amount,
                        round_off_account_id: payment_data.round_off_account_id,
                    });

                    setTotalPaidAmount(payment_data.payment_amount.toFixed(2));
                    setTotalRoundOff(payment_data.round_off_amount);
                    setIsPaymentModeDisabled(true)
                }
            });
        }
    }, [paymentID]);



    useEffect(() => {
        if (receiptID > 0 && paymentID > 0) {
            const data = {
                formdata: {
                    payment_id: paymentID,
                },
            };

            paymentService.paymentDetailsDataByID(data).then((res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    let payment_list = res.data.response_data;
                    const newData = payment_list.map((details) => {
                        return { ...details };
                    });
                    setPaymentPaidList(newData);
                }
            });


        }
    }, [receiptID, paymentID]);

    useEffect(() => {
        const total_paid_amount = paymentPaidList.reduce((a, v) => a = a + parseFloat(v.amount), 0);
        const total_bank_charges = paymentPaidList.reduce((a, v) => a = a + parseFloat(v.bank_charges), 0);
        
        setTotalBankCharges(parseFloat(commonUtility.sanitizeValue(total_bank_charges)).toFixed(2))
        setTotalPaidAmount(parseFloat(commonUtility.sanitizeValue(total_paid_amount)).toFixed(2))

        form.setFieldsValue({
            payment_amount: total_paid_amount.toFixed(2),
            total_bank_charges: total_bank_charges,
        })

        //  setRemainingAmount(totalPayableAmount -  totalPaidAmount)
    }, [paymentPaidList, receiptID, paymentID]);


    useEffect(() => {
            
        setRemainingAmount(
            parseFloat(totalPayableAmount) + parseFloat(totalBankCharges) - parseFloat(totalPaidAmount)
        );
    }, [totalPayableAmount,totalBankCharges,totalPaidAmount]);


    const handleCancel = () => {
        setOpenModal(false);
    };
    function changeLocation(placeToGo) {
        navigate(placeToGo, { replace: true });
        window.location.reload();
    }

    const resetFormFields = () => {
        const defaultFormValues = {
            mode: "ADD",                 
            voucher_id: 0,
            cr_ac_id: 0,
            student_account_id: 0,
            member_opening_balance: 0,
            receipt_id: 0,
            receipt_no: "",
            receipt_date: null,
            is_payment_done: "N",
            no_of_months: 0,
            is_general_receipt: "Y",
            entry_from: "G",
            round_off_amount: 0,
            round_off_account_id: ROUND_OFF_ACCOUNT_ID,
            total_bank_charges: 0,
            bank_charges_account_id: BANK_CHARGES_ACCOUNT_ID,
            is_gst_bill: 'Y',
            net_amount: 0,
            receipt_desc: "",            
            taxable_amount: 0,
            cgst_id: CGST_ID_9_PERCENT,
            cgst_rate: 9,
            cgst_amount: 0,
            sgst_id: SGST_ID_9_PERCENT,
            sgst_rate: 9,
            sgst_amount: 0,  
            narration: "",  
        };
    };

    const removeDetail = (index) => {
        const list = [...form.getFieldValue('general_receipt_detail')];
        list.splice(index, 1);
        form.setFieldsValue({ general_receipt_detail: list });
        onFormCalculation();
    }






    return (
        <div className="form-input-style">
            <Row
                className="login-first-step-row"
                style={{ background: "transparent" }}
            >
                <Col
                    className="form-format-type1 enrollment-form tap-registration"
                    xs={24}
                    xl={24}
                >
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onTournamentSave}
                        autoComplete="off"
                        initialValues={defaultFormValues}
                        onFieldsChange={(event) => onFormCalculation()}
                        onKeyUp={(event) => onFormCalculation}
                        onBlur={(event) => onFormCalculation}
                    >
                        <Collapse
                            bordered={false}
                            defaultActiveKey={["programme_jcp", "receipt_jcp"]}
                            onChange={onChangeCollapse}
                            expandIcon={({ isActive }) => (
                                <CaretRightOutlined rotate={isActive ? 90 : 0} />
                            )}
                        >
                            <Panel
                                header={
                                    <>
                                        <h4>Entry Info</h4>
                                    </>
                                }
                                key="programme_jcp"
                                className="mainPanel"
                            >
                                <Row gutter={20}>

                                    <Col xs={24} xl={24}>



                                        <Row gutter={20}>

                                            <Col xs={24} xl={6}>
                                                <Form.Item name="invoice_number" label="Receipt No">
                                                    <Input placeholder="" readOnly={true} />
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={6} >
                                            <Form.Item                                                
                                                name="receipt_desc"
                                                label="Name" rules={[
                                                    {
                                                        required: true,
                                                        message: 'Name is required',
                                                    },
                                                ]}>
                                               <Select className="text-left"
                                                    showSearch
                                                    placeholder="Search to Select"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        // option.children.includes(input)
                                                        option.children.toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    filterSort={(optionA, optionB) =>
                                                        optionA.children
                                                            .toLowerCase()
                                                            .localeCompare(optionB.children.toLowerCase())
                                                    }
                                                    placement="bottomLeft"
                                                    allowClear={true}


                                                >
                                                    {/* <Option >Select</Option> */}
                                                    {customerList.length > 0
                                                        ? customerList.map((desc_list) => (
                                                            <Option key={desc_list.customer_id} value={desc_list.customer_id} >{desc_list.customer_name}</Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} xl={6}>
                                                <Form.Item name="narration" label="Narration">
                                                    <TextArea rows={2} placeholder=""  />
                                                </Form.Item>
                                            </Col>

                                            {/* <Col xs={24} xl={6}>
                                                <Form.Item name="receipt_desc" label="Name" rules={[
                                                    {
                                                        required: true,
                                                        message: 'Name is required',
                                                    },
                                                ]}>
                                                    <Input placeholder=""  />
                                                </Form.Item>
                                            </Col> */}

                                            <Col xs={24} xl={6} hidden={true}>
                                                <Form.Item name="invoice_date_picker" label="Invoice Date" rules={[
                                                    {
                                                        required: false,
                                                        message: 'Invoice Date is required',
                                                    },
                                                ]}>
                                                    <DatePicker
                                                        format="DD/MM/YYYY"
                                                        // onChange={onDateOfBirthChange}
                                                        onChange={onDateChange}
                                                        style={{ width: "100%" }}
                                                        inputReadOnly={true}
                                                    />
                                                </Form.Item>
                                                <Form.Item name="invoice_date" label="Invoice Date" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                            </Col>

                                            <>
                                                {/* <Form.Item name="enrollment_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item> */}
                                                <Form.Item name="mode" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                {/* <Form.Item name="member_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="programme_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item> */}
                                                <Form.Item name="voucher_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="entry_from" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                {/* <Form.Item name="student_account_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item> */}
                                                <Form.Item name="payment_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="receipt_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="is_gst_bill" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="payable_amount" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="round_off_amount" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="round_off_account_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item label="Bank Charge" name="total_bank_charges" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item label="Bank Charge" name="bank_charges_account_id" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="payment_amount" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="total_taxable" label="" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>

                                                <Form.Item name="total_cgst_amount" label="" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>

                                                <Form.Item name="total_sgst_amount" label="" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>  
                                                <Form.Item name="net_amount" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                                <Form.Item name="is_general_receipt" hidden={true}>
                                                    <Input type="text" />
                                                </Form.Item>
                                            </>



                                        </Row>


                                        <Row>
                                            <Col xs={24} xl={24}>
                                               <BTATournamentDetailView 
                                                    form={form} 
                                                    removeDetail={removeDetail} 
                                                    onFormCalculation={onFormCalculation}
                                                    tournamentDetailList = {tournamentDetailList}
                                                    
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    {/** end of column */}


                                </Row>
                            </Panel>

                            <Panel
                                header={
                                    <>
                                        <h4>Receipt</h4>
                                    </>
                                }
                                key="receipt_jcp"
                                className="mainPanel"
                            >
                                <Collapse defaultActiveKey={["member_payment_panel"]} ghost>
                                    <Panel
                                        header="Receipt"
                                        key="member_payment_panel"
                                        className="member-payment component-panel innerPanel"
                                    >
                                        {/**
                       * Payments Module
                       */}

                                        <PaymentComponent
                                            enrollmentForm={form}
                                            detailInputKey="component_payment"
                                            addPaymentMode={addPaymentMode}
                                            paymentPaidList={paymentPaidList}
                                            removePayment={removePayment}
                                            remainingAmount={remainingAmount}
                                            isPaymentModeDisabled={isPaymentModeDisabled}
                                        />
                                    </Panel>
                                </Collapse>

                                <div className="totalDetails">
                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total Amount : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalAmount} </Text>
                                        </Col>
                                    </Row>
                                    <Row gutter={20} hidden={true}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total Discount : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalDiscountAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total Taxable : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalTaxableAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total CGST : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalCGSTAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total SGST : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalSGSTAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Total Net Amount : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalNetAmount} </Text>
                                        </Col>
                                    </Row>

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text >Round Off : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalRoundOff} </Text>
                                        </Col>
                                    </Row>
                                    {/* <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic>Total Payable : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{totalPayableAmount} </Text>
                                        </Col>
                                    </Row> */}


                                    {/* -----Previous Code-------
                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Total Payable = Amount to pay + Bank Charges(if any)  :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalPayableAmount} + {totalBankCharges}</Text>
                                        </Col>
                                    </Row> */}


                                    {/* New Changes on 02/04/24 =================Start Here*/}

                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Amount to pay :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalPayableAmount}</Text>
                                        </Col>
                                    </Row>
                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Bank Charges(if any) :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalBankCharges}</Text>
                                        </Col>
                                    </Row>
                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Total Payable :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{(Number(totalPayableAmount) + Number(totalBankCharges)).toFixed(2)}</Text>
                                        </Col>
                                    </Row>
                                    {/* New Changes on 02/04/24 =================== Ends Here*/}


                                    <Row gutter={20}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic style={{ fontSize: "18px", color: "#23910c" }}>Total Paid :  </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text style={{ fontSize: "18px", color: "#23910c" }}>{totalPaidAmount} </Text>
                                        </Col>
                                    </Row>


                                    <Row gutter={20} hidden={true}>
                                        <Col xs={24} xl={20} align="right">
                                            <Text italic>Short / Excess Amount : </Text>
                                        </Col>
                                        <Col xs={24} xl={4} align="right">
                                            <Text strong>{remainingAmount.toFixed(2)} </Text>
                                        </Col>
                                    </Row>
                                </div>

                                {/* <ModalWithMessageAndAction /> */}

                                <Row justify="end">
                                    <Col>
                                        <Form.Item>
                                            {isSaveLoaderEnable ? (
                                                <Spin />
                                            ) : (
                                                <>
                                                    <Button
                                                        htmlType="submit"
                                                        shape="round"
                                                       
                                                        className="custom-button-green"
                                                    >
                                                        Save <RightOutlined />
                                                    </Button>
                                                </>
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Panel>
                        </Collapse>
                    </Form>
                </Col>
            </Row>

            <Modal
                title={responseModalTitle}
                centered
                visible={openModal}
                open={openModal}
                // onCancel={handleCancel}
                closable={false}
                footer={[
                    <a href={printURL} target="_blank" rel="noopener noreferrer">
                        <Button htmlType="button" type="default"><PrinterOutlined /> Print</Button>
                    </a>

                    ,

                    <Link to={`/tournament/tournament-receipt-list/`} style={{ margin: 1 }}>
                        <Button htmlType="button" type="primary">
                            {" "}
                            <EyeOutlined /> View List
                        </Button>
                    </Link>,

                    <Link
                        to={`/tournament/entry/`}
                        onClick={() => changeLocation("/tournament/entry/")}
                        style={{ margin: 1 }}
                    >
                        <Button htmlType="button" type="danger">
                            {" "}
                            <EyeOutlined /> Add More
                        </Button>
                    </Link>,

                    // <Button key="submit" type="danger" onClick={()=> resetFormFields() }  style={{margin:1}} >
                    //   <PlusOutlined /> Add More
                    // </Button>,
                ]}
                style={{ width: "100px" }}
                className="responseModal"
            >
                <div style={{ textAlign: "center" }}>
                    <CheckCircleTwoTone
                        twoToneColor="#52c41a"
                        style={{ fontSize: "2.5rem" }}
                    />
                    <h3>{responseModalMessage}</h3>
                </div>
            </Modal>
        </div>
    );
};

export default TournamentEntry;
